/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Activation } from '../models/Activation';
import type { ActivationResponse } from '../models/ActivationResponse';
import type { CustomSendEmailReset } from '../models/CustomSendEmailReset';
import type { CustomUser } from '../models/CustomUser';
import type { CustomUserCreatePasswordRetype } from '../models/CustomUserCreatePasswordRetype';
import type { DashboardSmallUser } from '../models/DashboardSmallUser';
import type { PasswordResetConfirmRetype } from '../models/PasswordResetConfirmRetype';
import type { RetrieveDocumentGenerationJob } from '../models/RetrieveDocumentGenerationJob';
import type { SendEmailReset } from '../models/SendEmailReset';
import type { SetPasswordRetype } from '../models/SetPasswordRetype';
import type { SetUsername } from '../models/SetUsername';
import type { SlimUserGenerationJob } from '../models/SlimUserGenerationJob';
import type { UsernameResetConfirm } from '../models/UsernameResetConfirm';
import type { UserWithPermissions } from '../models/UserWithPermissions';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
  /**
   * User listing view that supports both full and slim data via query parameter.
   * @param search A search term.
   * @returns any
   * @throws ApiError
   */
  public static apiUsersList(search?: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users',
      query: {
        search: search,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiUsersCreateBulkUsersCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/users/create-bulk-users',
    });
  }
  /**
   * @param id A unique integer value identifying this user.
   * @returns UserWithPermissions
   * @throws ApiError
   */
  public static apiUsersFirmUsersRead(id: number): CancelablePromise<Array<UserWithPermissions>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users/firm_users/{id}/',
      path: {
        id: id,
      },
    });
  }
  /**
   * List generation jobs created by the authenticated user.
   * GET /api/users/me/document-generation-jobs
   * GET /api/users/me/document-generation-jobs?active_only=true
   *
   * By default returns only active (PENDING / IN_PROGRESS) jobs.  For active
   * jobs the backend syncs status with the external document processing service
   * so that the ``post_save`` signal fires and notifications are sent.
   *
   * Query params:
   * active_only  — ``true`` (default) returns only PENDING/IN_PROGRESS jobs.
   * ``false`` returns all jobs for the user.
   * processing_type — optional filter (e.g. ``CAP_TABLE``, ``FINANCIAL_MAPPING``).
   * @param activeOnly Return only active (PENDING/IN_PROGRESS) jobs.
   * @param processingType Filter by processing type.
   * @returns RetrieveDocumentGenerationJob
   * @throws ApiError
   */
  public static apiUsersMeDocumentGenerationJobsList(
    activeOnly: boolean = true,
    processingType?: string
  ): CancelablePromise<Array<RetrieveDocumentGenerationJob>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users/me/document-generation-jobs',
      query: {
        active_only: activeOnly,
        processing_type: processingType,
      },
    });
  }
  /**
   * List every generation job the authenticated user may access, slim and paginated.
   * @param page 1-based page number.
   * @param pageSize Items per page (max 50).
   * @param processingType Filter by processing type (e.g. CAP_TABLE).
   * @param status Filter by job status (PENDING, IN_PROGRESS, COMPLETED, FAILED) - e.g. COMPLETED to fetch only re-runnable jobs.
   * @param firmId Narrow to one firm. Only firms the caller is a member of return rows; any other id yields an empty page.
   * @param companyId Narrow to one company within the caller's accessible firms; an out-of-scope id yields an empty page.
   * @returns any
   * @throws ApiError
   */
  public static apiUsersMeDocumentGenerationJobsSlimList(
    page?: number,
    pageSize?: number,
    processingType?: string,
    status?: string,
    firmId?: number,
    companyId?: number
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SlimUserGenerationJob>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users/me/document-generation-jobs/slim',
      query: {
        page: page,
        page_size: pageSize,
        processing_type: processingType,
        status: status,
        firm_id: firmId,
        company_id: companyId,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiUsersPermissionsUpdate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/users/permissions',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiUsersPermissionsPartialUpdate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/users/permissions',
    });
  }
  /**
   * @param id
   * @param companyId
   * @returns any
   * @throws ApiError
   */
  public static apiUsersPermissionsUpdate1(id: string, companyId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/users/permissions/{id}/{company_id}',
      path: {
        id: id,
        company_id: companyId,
      },
    });
  }
  /**
   * @param id
   * @param companyId
   * @returns any
   * @throws ApiError
   */
  public static apiUsersPermissionsPartialUpdate1(id: string, companyId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/users/permissions/{id}/{company_id}',
      path: {
        id: id,
        company_id: companyId,
      },
    });
  }
  /**
   * @param id
   * @param companyId
   * @returns void
   * @throws ApiError
   */
  public static apiUsersPermissionsDelete(id: string, companyId: string): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/users/permissions/{id}/{company_id}',
      path: {
        id: id,
        company_id: companyId,
      },
    });
  }
  /**
   * User listing view that only returns staff users.
   * @param search A search term.
   * @returns DashboardSmallUser
   * @throws ApiError
   */
  public static apiUsersStaffList(search?: string): CancelablePromise<Array<DashboardSmallUser>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users/staff',
      query: {
        search: search,
      },
    });
  }
  /**
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static authUsersList(page?: number): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CustomUser>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/auth/users/',
      query: {
        page: page,
      },
    });
  }
  /**
   * @param data
   * @returns CustomUserCreatePasswordRetype
   * @throws ApiError
   */
  public static authUsersCreate(
    data: CustomUserCreatePasswordRetype
  ): CancelablePromise<CustomUserCreatePasswordRetype> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/users/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns ActivationResponse
   * @throws ApiError
   */
  public static authUsersActivation(data: Activation): CancelablePromise<ActivationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/users/activation/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns CustomSendEmailReset
   * @throws ApiError
   */
  public static authUsersResendActivation(data: CustomSendEmailReset): CancelablePromise<CustomSendEmailReset> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/users/resend_activation/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns CustomSendEmailReset
   * @throws ApiError
   */
  public static authUsersResetPassword(data: CustomSendEmailReset): CancelablePromise<CustomSendEmailReset> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/users/reset_password/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns PasswordResetConfirmRetype
   * @throws ApiError
   */
  public static authUsersResetPasswordConfirm(
    data: PasswordResetConfirmRetype
  ): CancelablePromise<PasswordResetConfirmRetype> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/users/reset_password_confirm/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns SendEmailReset
   * @throws ApiError
   */
  public static authUsersResetUsername(data: SendEmailReset): CancelablePromise<SendEmailReset> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/users/reset_username/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns UsernameResetConfirm
   * @throws ApiError
   */
  public static authUsersResetUsernameConfirm(data: UsernameResetConfirm): CancelablePromise<UsernameResetConfirm> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/users/reset_username_confirm/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns SetPasswordRetype
   * @throws ApiError
   */
  public static authUsersSetPassword(data: SetPasswordRetype): CancelablePromise<SetPasswordRetype> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/users/set_password/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns SetUsername
   * @throws ApiError
   */
  public static authUsersSetUsername(data: SetUsername): CancelablePromise<SetUsername> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/users/set_username/',
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this user.
   * @returns CustomUser
   * @throws ApiError
   */
  public static authUsersRead(id: number): CancelablePromise<CustomUser> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/auth/users/{id}/',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this user.
   * @param data
   * @returns CustomUser
   * @throws ApiError
   */
  public static authUsersUpdate(id: number, data: CustomUser): CancelablePromise<CustomUser> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/auth/users/{id}/',
      path: {
        id: id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this user.
   * @param data
   * @returns CustomUser
   * @throws ApiError
   */
  public static authUsersPartialUpdate(id: number, data: CustomUser): CancelablePromise<CustomUser> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/auth/users/{id}/',
      path: {
        id: id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this user.
   * @returns void
   * @throws ApiError
   */
  public static authUsersDelete(id: number): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/auth/users/{id}/',
      path: {
        id: id,
      },
    });
  }
}
